<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">工号</label>
						<el-input v-model="searchForm.gonghao" placeholder="工号" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">姓名</label>
						<el-input v-model="searchForm.xingming" placeholder="姓名" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">项目名称</label>
						<el-input v-model="searchForm.xiangmumingcheng" placeholder="项目名称" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="add" v-if="isAuth('gongzuojilu','新增')" type="success" @click="addOrUpdateHandler()">
						<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						新增
					</el-button>
					<el-button class="del" v-if="isAuth('gongzuojilu','删除')" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
					<el-upload
						class="upload-demo"
						:action="$base.url + 'gongzuojilu/importExcel'"
						:headers="{ token: $storage.get('Token') }"
						:on-success="importSuccess"
						:on-error="importError"
						:show-file-list="false"
						accept=".xls,.xlsx"
						style="display: inline-block; margin-left: 10px;">
						<el-button class="add" type="success">
							<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
							批量导入
						</el-button>
					</el-upload>
				</el-row>
			</el-form>
			<div :style='{"width":"100%","padding":"0","background":"none"}'>
				<el-table class="tables"
					:stripe='false'
					:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
					:border='true'
					v-if="isAuth('gongzuojilu','查看')"
					:data="dataList"
					v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="50" />
					<el-table-column :resizable='true' :sortable='true'  
						prop="gonghao"
						label="工号">
						<template slot-scope="scope">
							{{scope.row.gonghao}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xingming"
						label="姓名">
						<template slot-scope="scope">
							{{scope.row.xingming}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="bumen"
						label="部门">
						<template slot-scope="scope">
							{{scope.row.bumen}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xiangmumingcheng"
						label="项目名称">
						<template slot-scope="scope">
							{{scope.row.xiangmumingcheng}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xiangmuxiangqing"
						label="项目详情"
						width="200"
						show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.xiangmuxiangqing}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="jilushijian"
						label="记录时间"
						width="160">
						<template slot-scope="scope">
							{{scope.row.jilushijian}}
						</template>
					</el-table-column>
					<el-table-column width="300" label="操作">
						<template slot-scope="scope">
							<el-button class="view" v-if=" isAuth('gongzuojilu','查看')" type="success" @click="addOrUpdateHandler(scope.row.id,'info')">
								<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								查看
							</el-button>
							<el-button class="edit" v-if=" isAuth('gongzuojilu','修改') " type="success" @click="addOrUpdateHandler(scope.row.id)">
								<span class="icon iconfont icon-bianji" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								修改
							</el-button>
							<el-button class="del" v-if="isAuth('gongzuojilu','删除') " type="primary" @click="deleteHandler(scope.row.id )">
								<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				background
				:page-sizes="[10, 20, 30, 50]"
				:page-size="pageSize"
				:layout="layouts.join()"
				:total="totalPage"
				prev-text="上一页 "
				next-text="下一页 "
				:hide-on-single-page="false"
				:style='{"padding":"0","margin":"20px 0 0","whiteSpace":"nowrap","color":"inherit","width":"100%","fontSize":"inherit","fontWeight":"500"}'
			></el-pagination>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
	export default {
		data() {
			return {
				searchForm: {
					key: ""
				},
				form:{},
				dataList: [],
				pageIndex: 1,
				pageSize: 10,
				totalPage: 0,
				dataListLoading: false,
				dataListSelections: [],
				showFlag: true,
				addOrUpdateFlag:false,
				layouts: ['prev', 'pager', 'next', 'jumper', '->', 'sizes', 'total']
			}
		},
		components: {
			AddOrUpdate
		},
		created() {
		},
		mounted() {
			this.getDataList()
		},
	methods: {
		search() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 刷新数据列表（子组件调用）
		refreshDataList() {
			this.showFlag = true
			this.addOrUpdateFlag = false
			this.getDataList()
		},
		// 获取数据列表
		getDataList() {
				this.dataListLoading = true
				let params = {
					page: this.pageIndex,
					limit: this.pageSize,
					sort: 'id',
					order: 'desc'
				}
				
				// 搜索条件
				if(this.searchForm.gonghao) {
					params.gonghao = '%' + this.searchForm.gonghao + '%'
				}
				if(this.searchForm.xingming) {
					params.xingming = '%' + this.searchForm.xingming + '%'
				}
				if(this.searchForm.xiangmumingcheng) {
					params.xiangmumingcheng = '%' + this.searchForm.xiangmumingcheng + '%'
				}
				
				this.$http({
					url: "gongzuojilu/page",
					method: "get",
					params: params
				}).then(({ data }) => {
					if (data && data.code === 0) {
						this.dataList = data.data.list
						this.totalPage = data.data.total
					} else {
						this.dataList = []
						this.totalPage = 0
					}
					this.dataListLoading = false
				})
			},
			// 每页数
			sizeChangeHandle(val) {
				this.pageSize = val
				this.pageIndex = 1
				this.getDataList()
			},
			// 当前页
			currentChangeHandle(val) {
				this.pageIndex = val
				this.getDataList()
			},
			// 多选
			selectionChangeHandler(val) {
				this.dataListSelections = val
			},
			// 添加/修改
			addOrUpdateHandler(id, type) {
				this.showFlag = false
				this.addOrUpdateFlag = true
				if(type!='info'){
					type = 'else';
				}
				this.$nextTick(() => {
					this.$refs.addOrUpdate.init(id,type)
				})
			},
			// 导入成功
			importSuccess(response, file, fileList) {
				if (response && response.code === 0) {
					this.$message({
						message: response.msg || '导入成功',
						type: 'success',
						duration: 3000
					});
					this.getDataList();
				} else {
					this.$message.error(response.msg || '导入失败');
				}
			},
			// 导入失败
			importError(err, file, fileList) {
				this.$message.error('导入失败，请检查文件格式');
			},
			// 删除
			deleteHandler(id) {
				let ids = id
					? [id]
					: this.dataListSelections.map(item => {
							return item.id
					  })
				this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					this.$http({
						url: "gongzuojilu/delete",
						method: "post",
						data: ids
					}).then(({ data }) => {
						if (data && data.code === 0) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500
							})
							this.getDataList()
						} else {
							this.$message.error(data.msg)
						}
					})
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.main-content {
		.search {
			color: #fff;
		}
		.add {
			color: #fff;
		}
		.del {
			color: #fff;
		}
		.view {
			color: #fff;
		}
		.edit {
			color: #fff;
		}
	}

/* 覆盖Element UI的success绿色为青蓝色 #56B2C6 */
.el-button--success {
    background-color: #56B2C6 !important;
    border-color: #56B2C6 !important;
}

.el-button--success:hover,
.el-button--success:focus {
    background-color: #68bdd2 !important;
    border-color: #68bdd2 !important;
}

.el-tag--success {
    background-color: rgba(86,178,198,.1) !important;
    border-color: rgba(86,178,198,.2) !important;
    color: #56B2C6 !important;
}

/* 增加表格行高，让按钮不拥挤 */
::v-deep .el-table__row {
    height: 70px;
}

::v-deep .el-table td.el-table__cell {
    padding: 16px 0;
}

::v-deep .el-table__body td.el-table__cell .cell {
    line-height: 38px;
}

/* 调整操作列按钮间距 */
::v-deep .el-table__body td.el-table__cell .el-button {
    margin: 4px 3px;
}

</style>

